import {
    GET_GUEST_CHECKOUT, GET_GUEST_CHECKOUT_RESET,
    UPDATE_GUEST_CHECKOUT, UPDATE_GUEST_CHECKOUT_RESET,
    UPDATE_GUEST_CHECKOUT_CART_ITEM, UPDATE_GUEST_CHECKOUT_CART_ITEM_RESET,
    UPDATE_GUEST_CHECKOUT_CART_ITEM_DELIVERY_BY_PURCHASER,
    SUBMIT_GUEST_CHECKOUT, SUBMIT_GUEST_CHECKOUT_RESET,
    GUEST_CHECKOUT_UPDATE_PROFILE_IMAGE, GUEST_CHECKOUT_UPDATE_PROFILE_IMAGE_RESET,
    GUEST_CHECKOUT_REMOVE_CART_ITEM, GUEST_CHECKOUT_REMOVE_CART_ITEM_RESET
} from '../actions/guestCheckout';

const initialState = {
    guestCheckout: {
        cart: [],
        receipt: []
    },
    guestCheckoutPurchaserDelivery: [],
    submitGuestCheckoutOrderId: null,
    getGuestCheckoutError: null,
    getGuestCheckoutSuccess: null,
    updateGuestCheckoutError: null,
    updateGuestCheckoutSuccess: null,
    updateGuestCheckoutErrorMessage: null,
    updateGuestCheckoutCartItemError: null,
    updateGuestCheckoutCartItemSuccess: null,
    submitGuestCheckoutError: null,
    submitGuestCheckoutSuccess: null,
    submitGuestCheckoutEventTrackingData: null,
    guestCheckoutRemoveCartItemSuccess: null,
    guestCheckoutRemoveCartItemError: null,
    guestCheckoutRemoveCartItemCartItem: null,
    updateGuestCheckoutCartItemErrorMessage: null,
    submitGuestCheckoutErrorPayload: null
};

export default function guestCheckoutReducer(state = initialState, action) {
    switch (action.type) {
        case GUEST_CHECKOUT_REMOVE_CART_ITEM:
            return {
                ...state,
                ...(action.payload && action.payload.guestCheckoutRemoveCartItemSuccess && {
                    guestCheckout: action.payload.guestCheckout,
                    guestCheckoutRemoveCartItemSuccess: true
                }),
                guestCheckoutRemoveCartItemCartItem: action.payload.guestCheckoutRemoveCartItemCartItem,
                guestCheckoutRemoveCartItemError: action.error
            };
        case GUEST_CHECKOUT_REMOVE_CART_ITEM_RESET:
            return {
                ...state,
                guestCheckoutRemoveCartItemSuccess: initialState.guestCheckoutRemoveCartItemSuccess,
                guestCheckoutRemoveCartItemError: initialState.guestCheckoutRemoveCartItemError,
                guestCheckoutRemoveCartItemCartItem: initialState.guestCheckoutRemoveCartItemCartItem
            };
        case GET_GUEST_CHECKOUT:
            return {
                ...state,
                ...(action.payload && action.payload.getGuestCheckoutSuccess && {
                    guestCheckout: action.payload.guestCheckout,
                    getGuestCheckoutSuccess: true
                }),
                getGuestCheckoutError: action.error
            };
        case GET_GUEST_CHECKOUT_RESET:
            return {
                ...state,
                getGuestCheckoutSuccess: initialState.getGuestCheckoutSuccess,
                getGuestCheckoutError: initialState.getGuestCheckoutError
            };
        case UPDATE_GUEST_CHECKOUT:
            return {
                ...state,
                ...(action.payload && action.payload.updateGuestCheckoutSuccess && {
                    guestCheckout: action.payload.guestCheckout,
                    updateGuestCheckoutSuccess: true
                }),
                ...(action.payload && action.payload.message && action.error && {
                    updateGuestCheckoutErrorMessage: action.payload.message,
                }),
                updateGuestCheckoutError: action.error
            };
        case UPDATE_GUEST_CHECKOUT_RESET:
            return {
                ...state,
                updateGuestCheckoutSuccess: initialState.updateGuestCheckoutSuccess,
                updateGuestCheckoutError: initialState.updateGuestCheckoutError,
                updateGuestCheckoutErrorMessage: initialState.updateGuestCheckoutErrorMessage
            };
        case UPDATE_GUEST_CHECKOUT_CART_ITEM:
            return {
                ...state,
                ...(action.payload && action.payload.updateGuestCheckoutCartItemSuccess && {
                    guestCheckout: action.payload.guestCheckout,
                    updateGuestCheckoutCartItemSuccess: true
                }),
                updateGuestCheckoutCartItemError: action.error,
                updateGuestCheckoutCartItemErrorMessage: action.payload && action.payload.message
            };
        case UPDATE_GUEST_CHECKOUT_CART_ITEM_DELIVERY_BY_PURCHASER:
            return {
                ...state,
                ...(action.payload && action.payload.guestCheckoutPurchaserDelivery && {
                    guestCheckoutPurchaserDelivery: {
                      ...state.guestCheckoutPurchaserDelivery,
                        [action.payload.guestCheckoutPurchaserDelivery.id]: action.payload.guestCheckoutPurchaserDelivery.delivery_by_purchaser,
                    },
                })
            };
        case UPDATE_GUEST_CHECKOUT_CART_ITEM_RESET:
            return {
                ...state,
                updateGuestCheckoutCartItemSuccess: initialState.updateGuestCheckoutCartItemSuccess,
                updateGuestCheckoutCartItemError: initialState.updateGuestCheckoutCartItemError,
                updateGuestCheckoutCartItemErrorMessage: initialState.updateGuestCheckoutCartItemErrorMessage
            };
        case SUBMIT_GUEST_CHECKOUT:
            return {
                ...state,
                ...(action.payload && action.payload.submitGuestCheckoutSuccess && {
                    submitGuestCheckoutSuccess: true,
                    submitGuestCheckoutOrder: action.payload.order,
                    submitGuestCheckoutInvoice: action.payload.invoice,
                    submitGuestCheckoutEventTrackingData: action.payload.submitGuestCheckoutEventTrackingData,
                    submitGuestCheckoutVisiblePhoneId: action.payload.submitGuestCheckoutVisiblePhoneId
                }),
                ...(action.error && {
                    submitGuestCheckoutErrorPayload: action.payload
                }),
                submitGuestCheckoutError: action.error,
            };
        case SUBMIT_GUEST_CHECKOUT_RESET:
            return {
                ...state,
                submitGuestCheckoutSuccess: initialState.submitGuestCheckoutSuccess,
                submitGuestCheckoutError: initialState.submitGuestCheckoutError,
                submitGuestCheckoutEventTrackingData: initialState.submitGuestCheckoutEventTrackingData,
                submitGuestCheckoutErrorPayload: initialState.submitGuestCheckoutErrorPayload
            };
        case GUEST_CHECKOUT_UPDATE_PROFILE_IMAGE:
            return {
                ...state,
                ...(action.meta && action.meta.sent && {guestCheckoutUpdateProfileImageSuccess: true}),
                guestCheckoutUpdateProfileImageError: action.error
            };
        case GUEST_CHECKOUT_UPDATE_PROFILE_IMAGE_RESET:
            return {
                ...state,
                guestCheckoutUpdateProfileImageSuccess: initialState.guestCheckoutUpdateProfileImageSuccess,
                guestCheckoutUpdateProfileImageError: initialState.guestCheckoutUpdateProfileImageError
            };
        default:
            return state;
    }
}